<template>
  <div>
    <div class="d-flex align-items-center m-3 border-bottom pb-2 mb-4">
      <a href="javascript:;" class="fs-18 txt-grey-600" @click="backToDetail">
        {{ room ? room.name : "" }}
        <span class="spinner-border" role="status" v-if="!room">
          <span class="sr-only">Loading...</span>
        </span>
      </a>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mx-2"
      >
        <path
          d="M8.29492 17.09L12.8749 12.5L8.29492 7.91L9.70492 6.5L15.7049 12.5L9.70492 18.5L8.29492 17.09Z"
          fill="#667085"
        />
      </svg>
      <a href="javascript:;" class="fs-18 txt-grey-900 mb-0 disabled">
        {{
        mdt_disease
        ? $t("multidisciplinary_board.btn_edit_case")
        : $t("multidisciplinary_board.btn_add_case")
        }}
      </a>
    </div>
    <div class="container px-3">
      <div class="mb-3 d-flex align-items-center">
        <label for="typehoichan" class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
          <input type="radio" id="typehoichan" :value="0" class="mr-2" v-model="form.type" />
          <span>{{ $t("multidisciplinary_board.lbl_type_mdt") }}</span>
        </label>
        <label for="typetqm" class="d-flex align-items-center mr-2 fs-16 txt-grey-800">
          <input type="radio" id="typetqm" :value="1" class="mr-2" v-model="form.type" />
          <span>{{ $t("multidisciplinary_board.lbl_type_surgery") }}</span>
        </label>
      </div>
      <div class="mb-3" v-if="isMe">
        <label for="p-name" class="fs-14 fw-500 txt-grey-900">
          {{
          $t("multidisciplinary_board.lbl_patient_search")
          }}
        </label>
        <el-tooltip
          :content="$t('multidisciplinary_board.lbl_add_outpatiemt_warning')"
          placement="top"
          :disabled="!notPerson"
        >
          <el-select
            v-model="form.person_id"
            filterable
            remote
            clearable
            reserve-keyword
            :placeholder="$t('multidisciplinary_board.lbl_th_patient_search')"
            :no-match-text="$t('multidisciplinary_board.lbl_no_patient')"
            :no-data-text="$t('multidisciplinary_board.lbl_no_patient')"
            class="w-100"
            :remote-method="getPersons"
            :loading="loadingPerson"
            @change="onSelectPerson(persons)"
            :disabled="notPerson || isUpdate"
          >
            <el-option
              v-for="item in persons"
              :key="item.id + 'dtr'"
              :label="parsePersonName(item)"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-tooltip>
      </div>
      <div class="mb-3" v-if="isMe">
        <label for="p-name" class="fs-14 fw-500 txt-grey-900">
          {{
          $t("multidisciplinary_board.lbl_medical_record_select")
          }}
        </label>
        <el-tooltip
          :content="$t('multidisciplinary_board.lbl_add_mr_warning')"
          placement="top"
          :disabled="Boolean(form.person_id)"
        >
          <el-select
            v-model="form.mr_id"
            filterable
            remote
            clearable
            reserve-keyword
            :placeholder="$t('multidisciplinary_board.lbl_th_mr_search')"
            :no-match-text="$t('multidisciplinary_board.lbl_no_mr')"
            :no-data-text="$t('multidisciplinary_board.lbl_no_mr')"
            class="w-100"
            :remote-method="handleGetMedicalRecords"
            :loading="loadingMR"
            @change="handleSelectedMR(medicalRecords)"
            :disabled="notPerson || !form.person_id"
          >
            <el-option
              v-if="Boolean(form.person_id) && !isUpdate"
              :label="$t('multidisciplinary_board.lbl_add_medical_record')"
              :value="null"
            ></el-option>

            <el-option
              v-for="item in medicalRecords"
              :key="item.id + 'dtr'"
              :label="handleGetMRLabel(item)"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-tooltip>
      </div>
      <div class="mb-2 row">
        <div class="flex align-items-center col-6">
          <p
            class="fs-16 fw-600 txt-grey-900 mr-2 mb-0"
          >{{ $t("multidisciplinary_board.lbl_patient_info") }}</p>
          <div class="d-flex items-center" v-if="isMe">
            <div class="mx-2">
              <!-- <el-checkbox v-if="!isUpdate" class="mb-0" :disabled="isUpdate" v-model="notPerson">
                {{
                $t("multidisciplinary_board.chk_outpatient")
                }}
              </el-checkbox>-->
              <!-- <el-checkbox v-else class="mb-0" :disabled="isUpdate" v-model="is_outpatient">
                {{
                $t("multidisciplinary_board.chk_outpatient")
                }}
              </el-checkbox>-->
              <!-- </el-tooltip> -->
            </div>
            <el-tooltip
              :content="$t('multidisciplinary_board.lbl_outpatient_warning')"
              placement="top"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.031 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.7411 9.25718 8.87418C9.23529 9.00726 9.24055 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52854 9.44389 9.63643C9.52481 9.74433 9.62671 9.83475 9.74348 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.3474 11.345 9.22078 11.4978 9.13298C11.6505 9.04518 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71352C13.3828 7.25801 12.7035 7.00546 12 7Z"
                  fill="black"
                />
              </svg>
            </el-tooltip>
          </div>
        </div>
      </div>

      <!-- <el-tooltip
        content='Để thêm thông tin vui lòng chọn " Bệnh nhân ngoại viện "'
        placement="top"
        :disabled="notPerson || form.person_id"
      >-->
      <div :class="!notPerson ? 'region-disabled' : ''">
        <div class="mb-3">
          <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
            {{
            $t("multidisciplinary_board.lbl_patient_name")
            }}
          </label>
          <input
            v-model="form.patient_name"
            type="text"
            class="form-control patient_name fs-16 fw-300 txt-grey-900"
            :placeholder="$t('multidisciplinary_board.lbl_th_patient_name')"
          />
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-md-4">
              <label for="nam" class="fs-14 fw-500 txt-grey-900 required">
                {{
                $t("multidisciplinary_board.lbl_gender")
                }}
              </label>
            </div>
            <div class="col-md-8">
              <label
                for="bd"
                class="fs-14 fw-500 txt-grey-900 required"
                v-if="
                !aliasStatus || mdt_disease.alias.person_id !== form.person_id
              "
              >{{ $t("multidisciplinary_board.lbl_dob") }}</label>
              <label for="bd" class="fs-14 fw-500 txt-grey-900 required" v-else>
                {{ $t("multidisciplinary_board.lbl_age")
                }}
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 d-flex align-items-center">
              <label class="fs-14 fw-500 txt-grey-900 required d-md-none">
                {{
                $t("multidisciplinary_board.lbl_gender")
                }}
              </label>
              <label for="nam" class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
                <input type="radio" id="nam" :value="1" class="mr-2" v-model="form.patient_gender" />
                {{ $t("multidisciplinary_board.lbl_male")
                }}
              </label>
              <label for="nu" class="d-flex align-items-center mr-2 fs-16 txt-grey-800">
                <input type="radio" id="nu" :value="2" class="mr-2" v-model="form.patient_gender" />
                {{ $t("multidisciplinary_board.lbl_female")
                }}
              </label>
            </div>
            <div
              class="col-md-8"
              v-if="
              !aliasStatus || mdt_disease.alias.person_id !== form.person_id
            "
            >
              <input
                type="date"
                name="bd"
                id="bd"
                placeholder="Chọn ngày"
                class="form-control fs-16 fw-500 txt-grey-900"
                v-model="form.patient_birthday"
              />
            </div>
            <div class="col-md-8" v-else>
              <input
                name="bd"
                id="bd"
                type="number"
                :placeholder="$t('multidisciplinary_board.lbl_age')"
                class="form-control fs-16 fw-500 txt-grey-900"
                v-model="alias_form.alias_age"
              />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="p-name" class="fs-14 fw-500 txt-grey-900">
            {{
            $t("multidisciplinary_board.lbl_address")
            }}
          </label>
          <input
            type="text"
            class="form-control fs-16 fw-300 txt-grey-900"
            :placeholder="$t('multidisciplinary_board.lbl_th_address')"
            v-model="form.patient_address"
          />
        </div>
      </div>
      <!-- </el-tooltip> -->

      <div class="mb-3" v-if="isMe">
        <div class="mb-3" v-if="aliasStatus && mdt_disease.alias.person_id === form.person_id">
          <el-checkbox
            class="mb-0"
            :disabled="!!aliasStatus"
            v-model="aliasStatus"
          >{{ $t('lbl_alias_​​mode') }}</el-checkbox>
        </div>
        <div class="mb-3" v-else>
          <el-checkbox class="mb-0" v-model="modeAlias">
            {{
            $t('lbl_alias_​​mode')
            }}
          </el-checkbox>
        </div>
        <div v-if="checkedPolicy && modeAlias" class="bg-gray-50 p-3 rounded-md">
          <div class="mb-3">
            <div class="row">
              <div class="col-md-6">
                <label for="alias_name" class="fs-14 fw-500 txt-grey-900 required">
                  {{
                  $t("multidisciplinary_board.lbl_patient_name") }}
                </label>
              </div>
              <div class="col-md-6">
                <label for="alias_age" class="fs-14 fw-500 txt-grey-900 required capitalize">
                  {{
                  $t("multidisciplinary_board.lbl_age")
                  }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <input
                  id="alias_name"
                  v-model="alias_form.alias_name"
                  type="text"
                  class="form-control patient_name fs-16 fw-300 txt-grey-900 bg-white"
                  :placeholder="
                    $t('multidisciplinary_board.lbl_th_patient_name')
                  "
                />
              </div>
              <div class="col-md-6">
                <input
                  name="alias_age"
                  id="alias_age"
                  type="number"
                  :placeholder="$t('multidisciplinary_board.lbl_enter_age')"
                  class="form-control fs-16 fw-300 txt-grey-900 bg-white"
                  v-model="alias_form.alias_age"
                />
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="row">
              <div class="col-md-6">
                <label for="alias_gender" class="fs-14 fw-500 txt-grey-900 required">
                  {{
                  $t("multidisciplinary_board.lbl_gender") }}
                </label>
              </div>
              <div class="col-md-3">
                <label for="alias_pid" class="fs-14 fw-500 txt-grey-900">
                  {{
                  `PID`
                  }}
                </label>
              </div>
              <div class="col-md-3">
                <label for="alias_emr_id" class="fs-14 fw-500 txt-grey-900">
                  {{
                  `MHS`
                  }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex align-items-center">
                <label for="alias_male" class="d-flex align-items-center mr-4 fs-16 txt-grey-800">
                  <input
                    type="radio"
                    id="alias_male"
                    name="alias_gender"
                    :value="1"
                    class="mr-2"
                    v-model="alias_form.alias_gender"
                  />
                  {{
                  $t("multidisciplinary_board.lbl_male") }}
                </label>
                <label for="alias_female" class="d-flex align-items-center mr-2 fs-16 txt-grey-800">
                  <input
                    type="radio"
                    id="alias_female"
                    name="alias_gender"
                    :value="2"
                    class="mr-2"
                    v-model="alias_form.alias_gender"
                  />
                  {{
                  $t("multidisciplinary_board.lbl_female") }}
                </label>
              </div>
              <div class="col-md-3">
                <input
                  type="text"
                  class="form-control fs-16 fw-300 txt-grey-900 bg-white"
                  :placeholder="`PID`"
                  v-model="alias_form.alias_pid"
                />
              </div>
              <div class="col-md-3">
                <input
                  type="text"
                  class="form-control fs-16 fw-300 txt-grey-900 bg-white"
                  :placeholder="`MHS`"
                  v-model="alias_form.alias_emr_id"
                />
              </div>
            </div>
          </div>

          <div>
            <label for="p-name" class="fs-14 fw-500 txt-grey-900">
              {{
              $t("multidisciplinary_board.lbl_address")
              }}
            </label>
            <input
              type="text"
              class="form-control fs-16 fw-300 txt-grey-900 bg-white"
              :placeholder="$t('multidisciplinary_board.lbl_th_address')"
              v-model="alias_form.alias_address"
            />
          </div>
        </div>
      </div>

      <div class="mb-3 mt-2">
        <label for="p-name" class="fs-16 fw-700 txt-grey-900 required">
          {{
          $t("multidisciplinary_board.lbl_mdt_date")
          }}
        </label>
        <input
          v-model="form.date"
          type="date"
          class="form-control fs-16 fw-300 txt-grey-900"
          placeholder="Chọn ngày"
        />
      </div>

      <div class="mb-3">
        <div class="flex justify-between items-center mb-4">
          <p
            class="fs-16 fw-600 txt-grey-900 mb-0"
          >{{ $t("multidisciplinary_board.lbl_case_info") }}</p>
          <div class="flex justify-end items-center col-6">
            <svg
              class="mr-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.41 8.64C21.41 8.64 21.41 8.64 21.41 8.59C20.7054 6.66623 19.4269 5.00529 17.7475 3.83187C16.0681 2.65845 14.0688 2.02917 12.02 2.02917C9.97126 2.02917 7.97195 2.65845 6.29252 3.83187C4.6131 5.00529 3.33461 6.66623 2.63001 8.59C2.63001 8.59 2.63001 8.59 2.63001 8.64C1.84314 10.8109 1.84314 13.1891 2.63001 15.36C2.63001 15.36 2.63001 15.36 2.63001 15.41C3.33461 17.3338 4.6131 18.9947 6.29252 20.1681C7.97195 21.3416 9.97126 21.9708 12.02 21.9708C14.0688 21.9708 16.0681 21.3416 17.7475 20.1681C19.4269 18.9947 20.7054 17.3338 21.41 15.41C21.41 15.41 21.41 15.41 21.41 15.36C22.1969 13.1891 22.1969 10.8109 21.41 8.64ZM4.26001 14C3.91324 12.6892 3.91324 11.3108 4.26001 10H6.12001C5.96004 11.3285 5.96004 12.6715 6.12001 14H4.26001ZM5.08001 16H6.48001C6.71473 16.8918 7.05022 17.7541 7.48001 18.57C6.49931 17.9019 5.67951 17.0241 5.08001 16ZM6.48001 8H5.08001C5.67088 6.97909 6.4802 6.10147 7.45001 5.43C7.03057 6.24725 6.70515 7.10942 6.48001 8ZM11 19.7C9.77178 18.7987 8.90916 17.4852 8.57001 16H11V19.7ZM11 14H8.14001C7.9534 12.6732 7.9534 11.3268 8.14001 10H11V14ZM11 8H8.57001C8.90916 6.51477 9.77178 5.20132 11 4.3V8ZM18.92 8H17.52C17.2853 7.10816 16.9498 6.24594 16.52 5.43C17.5007 6.09807 18.3205 6.97594 18.92 8ZM13 4.3C14.2282 5.20132 15.0909 6.51477 15.43 8H13V4.3ZM13 19.7V16H15.43C15.0909 17.4852 14.2282 18.7987 13 19.7ZM15.86 14H13V10H15.86C16.0466 11.3268 16.0466 12.6732 15.86 14ZM16.55 18.57C16.9798 17.7541 17.3153 16.8918 17.55 16H18.95C18.3505 17.0241 17.5307 17.9019 16.55 18.57ZM19.74 14H17.88C17.9613 13.3365 18.0014 12.6685 18 12C18.0011 11.3315 17.961 10.6636 17.88 10H19.74C20.0868 11.3108 20.0868 12.6892 19.74 14Z"
                fill="#41464B"
              />
            </svg>
            <span class="fs-16 fw-600 mr-3 text-black">
              {{
              $t("common.select_lang")
              }}
            </span>
            <span class="fs-16 fw-600 mr-2">
              <span
                v-for="(selectedLang, index) in listSelectedLang"
                :key="index"
                v-text="
                index < listSelectedLang.length - 1
                  ? `${$t(`common.${selectedLang}`)}, `
                  : $t(`common.${selectedLang}`)
              "
              />
            </span>
            <el-dropdown class="mr-3">
              <span class="el-dropdown-link text-primary">
                <span class="fs-16 fw-600">+{{ $t("multidisciplinary_board.btn_add") }}</span>
                <i class="el-icon-arrow-down el-icon--right fs-16 fw-600"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(langCode, index) in Object.keys(
                  LANGUAGE_CODES_FOR_DISEASE
                )"
                  :key="index"
                  :disabled="checkShowFieldMultiLang(langCode)"
                >
                  <div
                    @click="setLang(langCode.toLowerCase())"
                  >{{ $t(`common.${langCode.toLowerCase()}`) }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- <a
              href="javascript:;"
              class="mr-3"
              @click="($event) => addFieldsLang"
              >+ {{ $t("multidisciplinary_board.btn_add") }}</a
            >-->

            <el-tooltip
              :content="
              $t(
                'multidisciplinary_board.lbl_tooltip_multi_lang_write_case_info'
              )
            "
              placement="top"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
                  fill="black"
                />
              </svg>
            </el-tooltip>
          </div>
        </div>
        <div class="mb-3" v-if="form.name">
          <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
            {{
            $t("multidisciplinary_board.lbl_case_name")
            }}
          </label>
          <input
            v-model="form.name"
            type="text"
            class="form-control fs-16 fw-300 txt-grey-900"
            :placeholder="$t('multidisciplinary_board.lbl_case_name')"
          />
        </div>
        <div class="mb-3">
          <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
            {{
            $t("multidisciplinary_board.lbl_admission_date")
            }}
          </label>
          <input
            type="datetime-local"
            class="form-control fs-16 fw-300 txt-grey-900"
            placeholder="Chọn ngày"
            v-model="form.admission_date"
          />
        </div>

        <div>
          <div>
            <div class="mb-3" v-if="isViLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
                <span>{{ $t("multidisciplinary_board.lbl_diagnose") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.VI
                "
                  class="ml-1"
                >({{ $t(`common.vi`) }})</span>
              </label>
              <input
                type="text"
                class="form-control fs-16 fw-300 txt-grey-900"
                placeholder
                v-model="form.patient_diagnostic.vi"
              />
            </div>
            <div class="mb-3" v-if="isEnLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
                <span>{{ $t("multidisciplinary_board.lbl_diagnose") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.EN
                "
                  class="ml-1"
                >({{ $t(`common.en`) }})</span>
              </label>
              <input
                type="text"
                class="form-control fs-16 fw-300 txt-grey-900"
                placeholder
                v-model="form.patient_diagnostic.en"
              />
            </div>
            <div class="mb-3" v-if="isFrLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
                <span>{{ $t("multidisciplinary_board.lbl_diagnose") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.FR
                "
                  class="ml-1"
                >({{ $t(`common.fr`) }})</span>
              </label>
              <input
                type="text"
                class="form-control fs-16 fw-300 txt-grey-900"
                placeholder
                v-model="form.patient_diagnostic.fr"
              />
            </div>
          </div>

          <div>
            <div class="mb-3" v-if="isViLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>
                  {{
                  $t("multidisciplinary_board.lbl_past_treatments")
                  }}
                </span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.VI
                "
                  class="ml-1"
                >({{ $t(`common.vi`) }})</span>
              </label>
              <EditorInput
                id="indication-vi-update-hc"
                :prop_text="form.indication.vi"
                @onChangeContent="(content) => form.indication.vi = content"
              />
            </div>
            <div class="mb-3" v-if="isEnLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>
                  {{
                  $t("multidisciplinary_board.lbl_past_treatments")
                  }}
                </span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.EN
                "
                  class="ml-1"
                >({{ $t(`common.en`) }})</span>
              </label>
              <EditorInput
                id="indication-en-update-hc"
                :prop_text="form.indication.en"
                @onChangeContent="(content) => form.indication.en = content"
              />
            </div>
            <div class="mb-3" v-if="isFrLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>
                  {{
                  $t("multidisciplinary_board.lbl_past_treatments")
                  }}
                </span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.FR
                "
                  class="ml-1"
                >({{ $t(`common.fr`) }})</span>
              </label>
              <EditorInput
                id="indication-fr-update-hc"
                :prop_text="form.indication.fr"
                @onChangeContent="(content) => form.indication.fr = content"
              />
            </div>
          </div>

          <div>
            <div class="mb-3" v-if="isViLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
                <span>
                  {{
                  $t("multidisciplinary_board.lbl_treatment_his")
                  }}
                </span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.VI
                "
                  class="ml-1"
                >({{ $t(`common.vi`) }})</span>
              </label>
              <EditorInput
                id="patient_diseases_current_cure-vi-update-hc"
                :prop_text="form.patient_diseases_current_cure.vi"
                @onChangeContent="(content) => form.patient_diseases_current_cure.vi = content"
              />
            </div>
            <div class="mb-3" v-if="isEnLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
                <span>
                  {{
                  $t("multidisciplinary_board.lbl_treatment_his")
                  }}
                </span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.EN
                "
                  class="ml-1"
                >({{ $t(`common.en`) }})</span>
              </label>
              <EditorInput
                id="patient_diseases_current_cure-en-update-hc"
                :prop_text="form.patient_diseases_current_cure.en"
                @onChangeContent="(content) => form.patient_diseases_current_cure.en = content"
              />
            </div>
            <div class="mb-3" v-if="isFrLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900 required">
                <span>
                  {{
                  $t("multidisciplinary_board.lbl_treatment_his")
                  }}
                </span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.FR
                "
                  class="ml-1"
                >({{ $t(`common.fr`) }})</span>
              </label>
              <EditorInput
                id="patient_diseases_current_cure-fr-update-hc"
                :prop_text="form.patient_diseases_current_cure.fr"
                @onChangeContent="(content) => form.patient_diseases_current_cure.fr = content"
              />
            </div>
          </div>

          <div>
            <div class="mb-3" v-if="isViLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>{{ $t("multidisciplinary_board.lbl_conclude") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.VI
                "
                  class="ml-1"
                >({{ $t(`common.vi`) }})</span>
              </label>
              <EditorInput
                id="conclusion-vi-update-hc"
                :prop_text="form.conclusion.vi"
                @onChangeContent="(content) => form.conclusion.vi = content"
              />
            </div>
            <div class="mb-3" v-if="isEnLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>{{ $t("multidisciplinary_board.lbl_conclude") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.EN
                "
                  class="ml-1"
                >({{ $t(`common.en`) }})</span>
              </label>
              <EditorInput
                id="conclusion-en-update-hc"
                :prop_text="form.conclusion.en"
                @onChangeContent="(content) => form.conclusion.en = content"
              />
            </div>
            <div class="mb-3" v-if="isFrLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>{{ $t("multidisciplinary_board.lbl_conclude") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.FR
                "
                  class="ml-1"
                >({{ $t(`common.fr`) }})</span>
              </label>
              <EditorInput
                id="conclusion-fr-update-hc"
                :prop_text="form.conclusion.fr"
                @onChangeContent="(content) => form.conclusion.fr = content"
              />
            </div>
          </div>

          <div>
            <div class="mb-3" v-if="isViLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>{{ $t("multidisciplinary_board.lbl_treatment") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.VI
                "
                  class="ml-1"
                >({{ $t(`common.vi`) }})</span>
              </label>
              <EditorInput
                id="treatment-vi-update-hc"
                :prop_text="form.treatment.vi"
                @onChangeContent="(content) => form.treatment.vi = content"
              />
            </div>
            <div class="mb-3" v-if="isEnLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>{{ $t("multidisciplinary_board.lbl_treatment") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.EN
                "
                  class="ml-1"
                >({{ $t(`common.en`) }})</span>
              </label>
              <EditorInput
                id="treatment-en-update-hc"
                :prop_text="form.treatment.en"
                @onChangeContent="(content) => form.treatment.en = content"
              />
            </div>
            <div class="mb-3" v-if="isFrLangShowField">
              <label for="p-name" class="fs-14 fw-500 txt-grey-900">
                <span>{{ $t("multidisciplinary_board.lbl_treatment") }}</span>
                <span
                  v-if="
                  $lang.toUpperCase() !== LANGUAGE_CODES_NAME_FOR_DISEASE.FR
                "
                  class="ml-1"
                >({{ $t(`common.fr`) }})</span>
              </label>
              <EditorInput
                id="treatment-fr-update-hc"
                :prop_text="form.treatment.fr"
                @onChangeContent="(content) => form.treatment.fr = content"
              />
            </div>
          </div>
        </div>

        <div class="mb-3">
          <label for="p-surgery_date" class="fs-14 fw-500 txt-grey-900">
            {{ $t("multidisciplinary_board.lbl_case_image") }}
            ({{
            totalImage
            }}/5)
          </label>
          <div class="d-flex">
            <div class="upload-container" v-for="(imgObj, i) in imageFiles" :key="i + 'amh'">
              <div class="upload-btn" @click="uploadFile(i)">
                <img v-if="imgObj.url" :src="imgObj.url" alt class="img-x" />
                <template v-else>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.7369 2.76175H8.08489C6.00489 2.75375 4.30089 4.41075 4.25089 6.49075V17.2277C4.20589 19.3297 5.87389 21.0697 7.97489 21.1147C8.01189 21.1147 8.04889 21.1157 8.08489 21.1147H16.0729C18.1629 21.0407 19.8149 19.3187 19.8029 17.2277V8.03775L14.7369 2.76175Z"
                      stroke="#20419B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.4756 2.75V5.659C14.4756 7.079 15.6246 8.23 17.0446 8.234H19.7986"
                      stroke="#20419B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.6416 9.90918V15.9502"
                      stroke="#20419B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.9869 12.2642L11.6419 9.90918L9.29688 12.2642"
                      stroke="#20419B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="robo-14-500 txt-pri">
                    {{
                    $t("multidisciplinary_board.lbl_image_select")
                    }}
                  </span>
                </template>
              </div>
              <input v-model="imgObj.name" class="upload-input" />
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-5">
        <button
          v-if="modeAlias"
          @click="onShowModalAliasConfirm(true)"
          class="btn bg-pri bd-pri text-white btn-save"
          :disabled="
            loading ||
            !form.patient_name ||
            !form.patient_birthday ||
            !form.patient_gender ||
            !form.admission_date ||
            !form.date ||
            (modeAlias &&
              checkedPolicy &&
              (!alias_form.alias_name ||
                !alias_form.alias_age ||
                !alias_form.alias_gender)) ||
            isNaN(form.type)
          "
        >
          {{
          mdt_disease
          ? $t("multidisciplinary_board.btn_save")
          : $t("multidisciplinary_board.btn_add")
          }}
        </button>
        <button
          v-else
          @click="saveMdtDiseases"
          class="btn bg-pri bd-pri text-white btn-save"
          :disabled="
          loading ||
          !form.patient_name ||
          (aliasStatus ? !alias_form.alias_age : !form.patient_birthday) ||
          !form.patient_gender ||
          !form.admission_date ||
          !form.date ||
          isNaN(form.type)
        "
        >
          {{
          mdt_disease
          ? $t("multidisciplinary_board.btn_save")
          : $t("multidisciplinary_board.btn_add")
          }}
        </button>
      </div>
    </div>
    <input
      type="file"
      ref="inputFile"
      accept=".jpeg, .jpg"
      @change="handleFileSelected"
      multiple
      class="d-none"
    />

    <div
      class="modal fade"
      id="modal__alias_policy"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="d-flex align-items-center bg-white modal-header mt-2">
            <h5
              class="fs-18 fw-700 txt-black text-left ml-4"
              id="exampleModalCenterTitle"
            >{{ $t(`lbl_terms_of_use_short`) }}</h5>
            <svg
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 18.4998L17.9998 6.5"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.9998 18.4998L6 6.5"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <form>
            <div class="modal-body">
              <div v-html="$t('lbl_terms_of_use')" class="mb-3" />

              <!-- <p>
                  Tôi chịu tránh nhiệm về việc lựa chọn Bí danh cho thông tin cá
                  nhân của bệnh nhân được đưa vào phiên Hội chẩn.
                </p>
                <p>
                  Tôi tôn trọng
                  <span class="font-bold italic">Quyền được tôn trọng bí mật riêng tư</span>
                  của bệnh nhân tại
                  <span
                    class="font-bold italic"
                  >Điều 8 Luật khám chữa bệnh, năm 2009</span>
                  khi dùng tính năng Bí danh trên HODO. Cụ thể:
                </p>
                <ol>
                  <li>
                    Được giữ bí mật thông tin về tình trạng sức khỏe và đời tư
                    được ghi trong hồ sơ bệnh án.
                  </li>
                  <li>
                    Thông tin quy định tại khoản 1 Điều này chỉ được phép công
                    bố khi người bệnh đồng ý hoặc để chia sẻ thông tin, kinh
                    nghiệm nhằm nâng cao chất lượng chẩn đoán, chăm sóc, điều
                    trị người bệnh giữa những người hành nghề trong nhóm trực
                    tiếp điều trị cho người bệnh hoặc trong trường hợp khác được
                    pháp luật quy định.
                  </li>
              </ol>-->

              <div class="mb-3">
                <el-checkbox
                  class="mb-0"
                  v-model="checkedPolicy"
                >{{ $t("lbl_I_confirm_that_I_have_read_and_agree_to_the_above_terms") }}</el-checkbox>
              </div>
              <div class="d-flex justify-content-between">
                <button
                  type="button"
                  class="btn bg-pri form-btn w-100 fs-16 fw-600 text-white"
                  :disabled="loading || !checkedPolicy"
                  @click="onCloseModalAlias(true)"
                >
                  <span class="spinner-border spinner-border-sm mr-2" role="status" v-if="loading"></span>
                  {{ $t('button.agree') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal__alias_confirm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="d-flex align-items-center bg-white modal-header mt-2">
            <h5 class="fs-18 fw-700 txt-black text-left ml-4" id="exampleModalCenterTitle">
              {{ $t(`lbl_confirmation`)
              }}
            </h5>
            <svg
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 18.4998L17.9998 6.5"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.9998 18.4998L6 6.5"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <p>{{ $t('lbl_the_case_will_be_added_to_the_mdt_consultation_room_in_alias_​​mode') }}</p>
                <p>
                  <label class="mb-0 font-bold mr-1">
                    {{
                    $t("multidisciplinary_board.lbl_patient_name")
                    }}:
                  </label>
                  <span>{{ alias_form.alias_name }}</span>
                </p>
                <p>
                  <label class="mb-0 font-bold mr-1">{{ $t("PID") }}:</label>
                  <span>{{ alias_form.alias_pid }}</span>
                </p>
                <p>
                  <label class="mb-0 font-bold mr-1">{{ $t("MHS") }}:</label>
                  <span>{{ alias_form.alias_emr_id }}</span>
                </p>
                <p>
                  <label class="mb-0 font-bold mr-1">{{ $t("multidisciplinary_board.lbl_gender") }}:</label>
                  <span>{{ getGender(alias_form.alias_gender) }}</span>
                </p>
                <p>
                  <label
                    class="mb-0 font-bold mr-1 capitalize"
                  >{{ $t("multidisciplinary_board.lbl_age") }}:</label>
                  <span>{{ alias_form.alias_age }}</span>
                </p>
                <p>
                  <label
                    class="mb-0 font-bold mr-1"
                  >{{ $t("multidisciplinary_board.lbl_address") }}:</label>
                  <span>{{ alias_form.alias_address }}</span>
                </p>
                <p class="font-bold italic">{{ $t('lbl_note__information_in_alias_​​mode') }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <button
                  type="button"
                  class="btn bg-pri form-btn w-100 fs-16 fw-600 text-white"
                  :disabled="loading"
                  @click="saveMdtDiseases"
                >
                  <span class="spinner-border spinner-border-sm mr-2" role="status" v-if="loading"></span>
                  {{ $t('button.agree') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import {
  LANGUAGE_CODES_FOR_DISEASE,
  LANGUAGE_CODES_NAME_FOR_DISEASE,
  LANGUAGE_CODES_NUMBER_FOR_DISEASE
} from '../../lang'
import mdtUtils from '../../utils/mdtUtils'
import appUtils from '../../utils/appUtils'
import EditorInput from '@/components/EditorInput.vue'
import { IS_OUT_PATIENT_TYPE } from '../../utils/constants'

export default {
  name: 'MdtDiseaseForm',
  props: ['mdt_disease', 'loading', 'room', 'isUpdate'],
  components: { EditorInput },
  data () {
    return {
      form: {
        mr_id: null,
        name: '',
        patient_gender: 1,
        patient_name: '',
        patient_birthday: '',
        patient_address: '',
        admission_date: window.moment().format('YYYY-MM-DD HH:mm'),
        type: 0,
        date: window.moment().format('YYYY-MM-DD'),
        code: '',
        person_id: null,
        patient_diagnostic: {
          vi: '',
          en: '',
          fr: ''
        },
        indication: {
          vi: '',
          en: '',
          fr: ''
        },
        patient_diseases_current_cure: {
          vi: '',
          en: '',
          fr: ''
        },
        conclusion: {
          vi: '',
          en: '',
          fr: ''
        },
        treatment: {
          vi: '',
          en: '',
          fr: ''
        }
      },
      alias_form: {
        alias_id: null,
        alias_gender: 1,
        alias_name: '',
        alias_age: '',
        alias_address: '',
        alias_pid: '',
        alias_emr_id: ''
      },
      selectedPerson: null,
      multilang: [
        {
          lang: LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()],
          patient_diagnostic: '',
          indication: '',
          patient_diseases_current_cure: '',
          conclusion: '',
          treatment: ''
        }
      ],
      listSelectedLang: [],
      showLang: '',
      isViLangShowField: false,
      isEnLangShowField: false,
      isFrLangShowField: false,
      imageFiles: {},
      currentImage: 1,
      persons: [],
      loadingPerson: false,
      notPerson: false,
      modeAlias: false,
      aliasStatus: false,
      showAliasModal: false,
      showAliasModalConfirm: false,
      checkedPolicy: false,
      LANGUAGE_CODES_FOR_DISEASE,
      LANGUAGE_CODES_NAME_FOR_DISEASE,
      LANGUAGE_CODES_NUMBER_FOR_DISEASE,
      appUtils,
      myInfo: {},
      isMe: true,
      loadingMR: false,
      medicalRecords: [],
      is_outpatient: false
    }
  },
  async created () {
    this.showLang =
      this.$lang || LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()
    this.isViLangShowField =
      this.$lang === LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()
    this.isEnLangShowField =
      this.$lang === LANGUAGE_CODES_NAME_FOR_DISEASE?.EN?.toLowerCase()
    this.isFrLangShowField =
      this.$lang === LANGUAGE_CODES_NAME_FOR_DISEASE?.FR?.toLowerCase()

    this.listSelectedLang = [this.showLang]
    this.myInfo = appUtils.getLocalUser()
    await this.getPersons(null, true)
  },
  watch: {
    $globalClinic () {
      this.handleGetMedicalRecords()
    },
    mdt_disease (data) {
      if (data) {
        this.isMe = this.myInfo?.doctor?.id === data?.doctor_id
        this.form.person_id = data.person_id
        this.handleSelectedPerson(data.person)
        this.is_outpatient = !!data?.person?.is_outpatient

        if (data.mr_id) {
          this.form.mr_id = data.mr_id
          this.handleGetMedicalRecords()
        }
        console.log(data)
        this.form.name = data.name
        this.form.patient_gender = data.patient_gender
        this.form.patient_name = data.patient_name
        this.form.patient_birthday = data.patient_birthday
        this.form.patient_address = data.patient_address
        this.form.admission_date = appUtils.formatInputDateTime(
          data.admission_date
        )
        this.form.type = data.type
        this.form.date = appUtils.formatInputDate(data.mdt_date)
        this.form.code = data.code

        if (data?.alias) {
          const alias = data.alias

          this.aliasStatus = !!alias.status
          this.alias_form.alias_id = alias.id
          this.alias_form.alias_gender = alias.alias_gender
          this.alias_form.alias_name = alias.alias_name
          this.alias_form.alias_age = alias.alias_age
          this.alias_form.alias_address = alias.alias_address
          this.alias_form.alias_pid =
            alias.alias_pid ||
            appUtils.convertString({ value: data?.person?.code, length: 5 }) ||
            ''
          this.alias_form.alias_emr_id =
            alias.alias_emr_id ||
            appUtils.convertString({ value: data?.code, length: 9 }) ||
            ''
        } else {
          this.alias_form.alias_pid =
            appUtils.convertString({ value: data?.person?.code, length: 5 }) ||
            ''
          this.alias_form.alias_emr_id =
            appUtils.convertString({ value: data?.code, length: 9 }) || ''
        }

        this.showLang =
          data.multilang.length > 0 &&
          typeof LANGUAGE_CODES_NUMBER_FOR_DISEASE?.[
            data.multilang?.[0]?.['lang']
          ]?.toLowerCase() !== 'undefined'
            ? LANGUAGE_CODES_NUMBER_FOR_DISEASE?.[
                data.multilang?.[0]?.['lang']
              ]?.toLowerCase()
            : this.$lang || LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()

        this.listSelectedLang = []

        // Reset fields multi lang
        this.isViLangShowField = false
        this.isEnLangShowField = false
        this.isFrLangShowField = false

        // if (data.medical_record) {
        //   this.handleSelectedPerson(data.person)
        // }

        const newMultiLang = []
        const setForm = data => {
          _.forEach(data, value => {
            let _obj = {
              lang: Number(value.lang),
              patient_diagnostic: value.patient_diagnostic,
              patient_diseases_current_cure:
                value.patient_diseases_current_cure,
              indication: value.indication,
              conclusion: value.conclusion,
              treatment: value.treatment
            }

            if (Number(value.lang) === LANGUAGE_CODES_FOR_DISEASE?.VI) {
              this.isViLangShowField = true
              this.form.patient_diagnostic.vi = value.patient_diagnostic || ''
              this.form.indication.vi = value.indication || ''
              this.form.patient_diseases_current_cure.vi =
                value.patient_diseases_current_cure || ''
              this.form.conclusion.vi = value.conclusion || ''
              this.form.treatment.vi = value.treatment || ''
              this.listSelectedLang.push(
                LANGUAGE_CODES_NUMBER_FOR_DISEASE?.[
                  Number(value.lang)
                ].toLowerCase()
              )
            }

            if (Number(value.lang) === LANGUAGE_CODES_FOR_DISEASE?.EN) {
              this.isEnLangShowField = true
              this.form.patient_diagnostic.en = value.patient_diagnostic || ''
              this.form.indication.en = value.indication || ''
              this.form.patient_diseases_current_cure.en =
                value.patient_diseases_current_cure || ''
              this.form.conclusion.en = value.conclusion || ''
              this.form.treatment.en = value.treatment || ''
              this.listSelectedLang.push(
                LANGUAGE_CODES_NUMBER_FOR_DISEASE?.[
                  Number(value.lang)
                ].toLowerCase()
              )
            }

            if (Number(value.lang) === LANGUAGE_CODES_FOR_DISEASE?.FR) {
              this.isFrLangShowField = true
              this.form.patient_diagnostic.fr = value.patient_diagnostic || ''
              this.form.indication.fr = value.indication || ''
              this.form.patient_diseases_current_cure.fr =
                value.patient_diseases_current_cure || ''
              this.form.conclusion.fr = value.conclusion || ''
              this.form.treatment.fr = value.treatment || ''
              this.listSelectedLang.push(
                LANGUAGE_CODES_NUMBER_FOR_DISEASE?.[
                  Number(value.lang)
                ].toLowerCase()
              )
            }

            newMultiLang.push(_obj)
          })
        }

        if (data.multilang.length) {
          setForm(data.multilang)
        } else {
          this.showLang = this.$lang
          const defaultData = {
            lang: appUtils.getLangId(this.$lang),
            patient_diagnostic: data?.patient_diagnostic || null,
            patient_diseases_current_cure:
              data?.patient_diseases_current_cure || null,
            conclusion: data?.conclusion || null,
            treatment: data?.treatment || null,
            indication: data?.indication || null
          }
          const defaultMultiLang = [defaultData]

          setForm(defaultMultiLang)
        }

        this.multilang = newMultiLang
      } else {
        this.form.mr_id = null
        this.form.person_id = null
        this.form.name = ''
        this.form.patient_gender = 1
        this.form.patient_name = ''
        this.form.patient_birthday = ''
        this.form.patient_address = ''
        this.form.admission_date = ''
        this.form.type = 0
        this.form.date = appUtils.formatInputDate() || ''
        this.form.code = ''

        this.aliasStatus = false
        this.alias_form.alias_id = null
        this.alias_form.alias_gender = 1
        this.alias_form.alias_name = ''
        this.alias_form.alias_age = ''
        this.alias_form.alias_address = ''
        this.alias_form.alias_pid = ''
        this.alias_form.alias_emr_id = ''

        this.showLang =
          this.$lang || LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()
        this.isViLangShowField =
          this.$lang === LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()
        this.isEnLangShowField =
          this.$lang === LANGUAGE_CODES_NAME_FOR_DISEASE?.EN?.toLowerCase()
        this.isFrLangShowField =
          this.$lang === LANGUAGE_CODES_NAME_FOR_DISEASE?.FR?.toLowerCase()

        this.listSelectedLang = [this.showLang]
      }
      this.makeImageSize()
    },
    notPerson (newStatus) {
      this.changeNotPerson(newStatus)
    },
    modeAlias (newStatus) {
      if (newStatus) {
        if (this.form.person_id || this.form.patient_name?.length) {
          this.modeAlias = true
          this.onShowModalAliasPolicy(true)
        } else {
          this.$toast.open({
            message: this.$t('Không có thông tin bệnh nhân'),
            type: 'error'
          })
          this.modeAlias = false
          this.checkedPolicy = false
          // this.resetAliasInfo()
        }
      } else {
        this.modeAlias = false
        this.checkedPolicy = false
        // this.resetAliasInfo()
      }
    },
    checkedPolicy (newStatus) {
      this.changeModeAlias(newStatus)
    }
  },
  computed: {
    // aliasStatusValue () {
    //   this.aliasStatus =
    //     this.mdt_disease.alias.person_id === this.form.person_id
    //   return this.aliasStatus
    // },
    // convertPID () {
    //   const str = appUtils.convertString({ value: this.mdt_disease?.alias?.alias_pid, length: 5 })
    //   this.alias_form.alias_pid = str
    //   return str
    // },
    // convertMHS () {
    //   const str = appUtils.convertString({ value: this.mdt_disease?.alias?.alias_emr_id, length: 9 })
    //   this.alias_form.alias_emr_id = str
    //   return str
    // },
    totalImage () {
      let total = 0
      for (const i in this.imageFiles) {
        const img = this.imageFiles[i]
        if (img.url) total++
      }
      return total
    },
    textMul () {
      return this.$t(`common.${this.showLang}`)
    },
    addFieldsLang () {
      switch (this.showLang) {
        case LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase():
          if (!this.isViLangShowField) {
            this.isViLangShowField = true
            this.multilang.push({
              lang: LANGUAGE_CODES_FOR_DISEASE?.VI,
              patient_diagnostic: '',
              indication: '',
              patient_diseases_current_cure: '',
              conclusion: '',
              treatment: ''
            })
          }
          break
        case LANGUAGE_CODES_NAME_FOR_DISEASE?.EN?.toLowerCase():
          if (!this.isEnLangShowField) {
            this.isEnLangShowField = true
            this.multilang.push({
              lang: LANGUAGE_CODES_FOR_DISEASE?.EN,
              patient_diagnostic: '',
              indication: '',
              patient_diseases_current_cure: '',
              conclusion: '',
              treatment: ''
            })
          }
          break
        case LANGUAGE_CODES_NAME_FOR_DISEASE?.FR?.toLowerCase():
          if (!this.isFrLangShowField) {
            this.isFrLangShowField = true
            this.multilang.push({
              lang: LANGUAGE_CODES_FOR_DISEASE?.FR,
              patient_diagnostic: '',
              indication: '',
              patient_diseases_current_cure: '',
              conclusion: '',
              treatment: ''
            })
          }
          break
        default:
          break
      }
    },
    formatterMdtDate: {
      get () {
        return appUtils.formatInputDateTime(this.mdt_disease?.date) || ''
      },
      set (newDate) {
        this.form.date = newDate
        return newDate
      }
    },
    formatterAdmissionDate: {
      get () {
        return (
          appUtils.formatInputDateTime(this.mdt_disease?.admission_date) || ''
        )
      },
      set (newDate) {
        this.form.admission_date = newDate
        return newDate
      }
    }
  },
  mounted () {
    const self = this
    self.makeImageSize()

    window.$(document).ready(function () {
      window.$('#modal__alias_policy').on('hide.bs.modal', function (e) {
        self.showAliasModal = false
        if (!self.checkedPolicy) {
          self.modeAlias = false
        }
      })
    })
  },
  methods: {
    onShowModalAliasPolicy () {
      this.showAliasModal = true
      this.resetAliasInfo()
      window.$('#modal__alias_policy').modal('show')
    },
    onCloseModalAlias () {
      this.showAliasModal = false
      window.$('#modal__alias_policy').modal('hide')
    },
    onShowModalAliasConfirm () {
      this.showAliasModalConfirm = true
      window.$('#modal__alias_confirm').modal('show')
    },
    onCloseModalAliasConfirm () {
      this.showAliasModalConfirm = false
      window.$('#modal__alias_confirm').modal('hide')
    },
    getGender (data) {
      return mdtUtils.getGender(data)
    },
    checkShowFieldMultiLang (langCode) {
      switch (langCode) {
        case LANGUAGE_CODES_NAME_FOR_DISEASE?.VI:
          return this.isViLangShowField
        case LANGUAGE_CODES_NAME_FOR_DISEASE?.EN:
          return this.isEnLangShowField
        case LANGUAGE_CODES_NAME_FOR_DISEASE?.FR:
          return this.isFrLangShowField

        default:
          break
      }
    },
    setLang (langVal) {
      this.showLang = langVal

      const hasSelectedLang = this.listSelectedLang.includes(langVal)

      if (hasSelectedLang) return

      this.listSelectedLang.push(langVal)

      return this.addFieldsLang
    },
    changeNotPerson (newStatus) {
      this.modeAlias = false

      if (newStatus && this.form.person_id) {
        if (
          confirm(
            this.$t(
              'multidisciplinary_board.lbl_selected_patient_info_will_be_discarded'
            )
          )
        ) {
          this.resetPersonInfo()
        } else {
          this.notPerson = false
        }
      } else {
        this.resetPersonInfo()
      }
    },
    changeModeAlias (newStatus) {
      if (newStatus) {
        if (this.alias_form.alias_id) return

        if (
          !this.alias_form.alias_id &&
          (this.form.person_id || this.form.patient_name?.length)
        ) {
          this.checkedPolicy = true
        } else {
          this.checkedPolicy = false
        }
      } else {
        this.checkedPolicy = false
      }
    },
    resetPersonInfo () {
      this.form.person_id = null
      this.form.patient_gender = 1
      this.form.patient_name = ''
      this.form.patient_birthday = ''
      this.form.patient_address = ''
      this.form.mr_id = ''
    },
    resetAliasInfo () {
      this.alias_form.alias_name = ''
      this.alias_form.alias_age = ''
      this.alias_form.alias_gender = 1
      this.alias_form.alias_pid =
        appUtils.convertString({
          value: this.mdt_disease?.person?.code,
          length: 5
        }) ||
        appUtils.convertString({
          value: this.selectedPerson?.code,
          length: 5
        }) ||
        ''
      this.alias_form.alias_emr_id =
        appUtils.convertString({ value: this.mdt_disease?.code, length: 9 }) ||
        ''
      this.alias_form.alias_address = ''
    },
    handleSelectedPerson (person) {
      const exist = this.persons.find(p => person.id === p.id)
      if (!exist) this.persons.unshift(person)
    },
    onClose () {
      this.$emit('onClose')
    },
    async saveMdtDiseases () {
      const { form, alias_form, imageFiles } = this
      form.date = appUtils.formatInputDate(form.date)
      form.admission_date = appUtils.formatInputDateTime(form.admission_date)
      form.patient_name = form.patient_name.toUpperCase()
      form.is_outpatient = this.isUpdate
        ? this.is_outpatient
          ? IS_OUT_PATIENT_TYPE.YES
          : IS_OUT_PATIENT_TYPE.NO
        : this.notPerson
          ? IS_OUT_PATIENT_TYPE.YES
          : IS_OUT_PATIENT_TYPE.NO

      const formData = new FormData()
      let isError = false
      let alias_params = null

      if (this.mdt_disease?.alias) {
        if (!this.modeAlias && !this.aliasStatus) {
          alias_params = {
            ...alias_form,
            alias_name: alias_form.alias_name?.toUpperCase(),
            status: 0
          }
        } else {
          alias_params = {
            ...alias_form,
            alias_name: alias_form.alias_name?.toUpperCase(),
            status: 1
          }
        }
      } else {
        if (this.modeAlias && alias_form.alias_name?.length) {
          alias_params = {
            ...alias_form,
            alias_name: alias_form.alias_name?.toUpperCase(),
            status: 1
          }
        }
      }

      const newMultiLang = this.multilang?.map((value, index) => {
        let data = {}

        if (Number(value.lang) === LANGUAGE_CODES_FOR_DISEASE.VI) {
          data = {
            ...value,
            patient_diagnostic: this.form.patient_diagnostic.vi,
            indication: this.form.indication.vi,
            patient_diseases_current_cure: this.form
              .patient_diseases_current_cure.vi,
            conclusion: this.form.conclusion.vi,
            treatment: this.form.treatment.vi
          }
        } else if (Number(value.lang) === LANGUAGE_CODES_FOR_DISEASE.EN) {
          data = {
            ...value,
            patient_diagnostic: this.form.patient_diagnostic.en,
            indication: this.form.indication.en,
            patient_diseases_current_cure: this.form
              .patient_diseases_current_cure.en,
            conclusion: this.form.conclusion.en,
            treatment: this.form.treatment.en
          }
        } else if (Number(value.lang) === LANGUAGE_CODES_FOR_DISEASE.FR) {
          data = {
            ...value,
            patient_diagnostic: this.form.patient_diagnostic.fr,
            indication: this.form.indication.fr,
            patient_diseases_current_cure: this.form
              .patient_diseases_current_cure.fr,
            conclusion: this.form.conclusion.fr,
            treatment: this.form.treatment.fr
          }
        } else {
          data = value
        }

        return data
      })

      if (!newMultiLang?.length) {
        alert(this.$t('multidisciplinary_board.invalid_save_concluding'))
      } else {
        _.forEach(newMultiLang, value => {
          if (
            !value.patient_diagnostic ||
            value.patient_diagnostic?.trim() === '' ||
            value.patient_diagnostic === null ||
            !value.patient_diseases_current_cure ||
            value.patient_diseases_current_cure?.trim() === '' ||
            value.patient_diseases_current_cure === null
          ) {
            isError = true
            alert(this.$t('multidisciplinary_board.invalid_save_concluding'))
          }
        })
      }

      if (isError) {
        return
      }

      _.forEach(newMultiLang, (value, index) => {
        typeof value.lang !== 'undefined' &&
          formData.append(`multilang[${index}][lang]`, value.lang)
        value.patient_diagnostic &&
          formData.append(
            `multilang[${index}][patient_diagnostic]`,
            value.patient_diagnostic
          )
        value.indication &&
          formData.append(`multilang[${index}][indication]`, value.indication)
        value.patient_diseases_current_cure &&
          formData.append(
            `multilang[${index}][patient_diseases_current_cure]`,
            value.patient_diseases_current_cure
          )
        value.conclusion &&
          formData.append(`multilang[${index}][conclusion]`, value.conclusion)
        value.treatment &&
          formData.append(`multilang[${index}][treatment]`, value.treatment)
      })

      form.clinic_id = this.$globalClinic.id

      for (const key in form) {
        if (!_.isNil(form[key])) formData.set(key, form[key])
      }

      for (const i in imageFiles) {
        const imgObj = imageFiles[i]
        if (!imgObj) continue
        if (imgObj.fileRaw) formData.set('image_' + i, imgObj.fileRaw)
        if (imgObj.name) formData.set('image_name_' + i, imgObj.name)
      }

      formData.delete('patient_diagnostic')
      formData.delete('patient_diseases_current_cure')
      formData.delete('conclusion')
      formData.delete('treatment')
      formData.delete('indication')
      formData.append(
        `patient_diagnostic`,
        typeof form.patient_diagnostic[this.$lang] === 'string' ? form.patient_diagnostic[this.$lang] : form.patient_diagnostic[0]
      )
      formData.append(
        `patient_diseases_current_cure`,
        typeof form.patient_diseases_current_cure[this.$lang] === 'string' ? form.patient_diseases_current_cure[this.$lang]
          : form.patient_diseases_current_cure[0]
      )
      formData.append(
        `conclusion`,
        typeof form.conclusion[this.$lang] === 'string' ? form.conclusion[this.$lang] : form.conclusion[0]
      )
      formData.append(
        `treatment`,
        typeof form.treatment[this.$lang] === 'string' ? form.treatment[this.$lang] : form.treatment[0]
      )
      formData.append(
        `indication`,
        typeof form.indication[this.$lang] === 'string' ? form.indication[this.$lang] : form.indication[0]
      )
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1])
      // }
      // console.log(alias_params)

      this.onCloseModalAliasConfirm(true)
      this.$emit('submit', formData, alias_params, form.patient_diagnostic.vi)
      this.$emit('refresh')
    },

    backToDetail () {
      this.$router.push({ name: 'ListMdt', query: { mdtid: this.room?.id } })
    },
    makeImageSize () {
      const images = {}
      for (let i = 1; i <= 5; i++) {
        images[i] = {
          url: this.mdt_disease && this.mdt_disease['image_url_' + i],
          name: this.mdt_disease && this.mdt_disease['image_name_' + i]
        }
      }
      this.imageFiles = images
    },
    uploadFile (index) {
      this.currentImage = index
      this.$refs.inputFile.click()
    },
    handleFileSelected (evt) {
      const file = evt.target.files[0]
      const { currentImage: index } = this
      this.$set(this.imageFiles, index, {
        ...this.imageFiles[index],
        url: URL.createObjectURL(file),
        fileRaw: file
      })
      evt.target.value = null
    },
    async getPersonDetail () {
      const params = {
        ...this.params,
        //   org_id: appUtils.getDoctorClinic().org_id,
        ws_id: this.$globalClinic?.id,
        page_num: this.paginationProp.currentPage,
        page_size: this.paginationProp.pageSize,
        keyword: this.search,
        sort: 'updated_at',
        order: 'desc',
        connect_status: this.connect_status
      }
      if (!params.connect_status) delete params.connect_status

      await this.$rf
        .getRequest('DoctorRequest')
        .getPersonList(params)
        .then(res => {
          this.contacts = res.data
          this.paginationProp = {
            totalItems: res.data.page.total,
            pageSize: res.data.page.page_size,
            currentPage: res.data.page.page_num
          }
        })
    },
    async getPersons (search, firstTime) {
      if (!this.$globalClinic && !this.$globalClinic.id) return
      let self = this
      const params = {
        ws_id: this.$globalClinic?.id,
        page_num: 1,
        page_size: 1000,
        keyword: search,
        sort: 'updated_at',
        order: 'desc'
      }

      this.loadingPerson = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getPersonList(params)
        .then(r => {
          self.persons = r.data?.data
          if (firstTime && this.mdt_disease?.person) {
            this.handleSelectedPerson(this.mdt_disease?.person)
          }
          return r
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.loadingPerson = false
        })
    },
    parsePersonName (item) {
      const dob =
        item?.alias && item?.alias?.alias_age
          ? `${item?.alias?.alias_age} ${this.$t(
            'multidisciplinary_board.lbl_age'
          )}`
          : item.birthday
            ? moment(item.birthday).format('DD/MM/YYYY')
            : ''
      return (
        item.name +
        (item?.pid ? ` (${item?.pid})` : '') +
        (item.birthday ? ' - ' + dob : '')
      )
    },
    onSelectPerson (items) {
      const item = items.find(p => p.id === this.form.person_id)
      console.log(item)

      this.selectedPerson = item
      this.alias_form.alias_pid = appUtils.convertString({
        value: item?.code,
        length: 5
      })

      if (
        item?.id === this.mdt_disease?.alias.person_id &&
        this.mdt_disease?.alias.status
      ) {
        this.checkedPolicy = false
        this.modeAlias = false
        this.form.patient_gender = this.mdt_disease.alias.alias_gender
        this.form.patient_name = this.mdt_disease.alias.alias_name
        this.form.patient_birthday = this.mdt_disease.alias.alias_birthday
        this.form.patient_address = this.mdt_disease.alias.alias_address
        this.form.person_id = this.mdt_disease.alias.person_id
      } else {
        this.form.patient_gender = item?.gender
        this.form.patient_name = item?.name
        this.form.patient_birthday = appUtils.formatInputDate(item?.birthday)
        this.form.patient_address = item?.address
        this.form.person_id = item?.id
      }
      this.form.mr_id = null
      this.handleGetMedicalRecords()
    },
    async handleGetMedicalRecords (search) {
      const id = this.$globalClinic.id
      if (!id || !this.form?.person_id) return
      const response = await this.$rf
        .getRequest('DoctorRequest')
        .getMediaRecordByPersonId(this.form.person_id, {
          search,
          limit: 1000,
          clinic_id: id
        })
      this.medicalRecords = response.data?.data || []
    },
    handleGetMRLabel (mrInfo) {
      if (mrInfo?.ref_id) {
        return `${mrInfo?.medical_record_name || ''} - ${mrInfo.ref_id}`
      } else {
        return `${mrInfo?.medical_record_name}`
      }
    },
    handleSelectedMR (mrList) {
      const mrInfo = mrList.find(item => item.id === this.form.mr_id)
      this.handleUpdateForm(mrInfo)
    },
    handleUpdateForm (data) {
      if (data) {
        this.showLang = LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()
        this.form.admission_date = window
          .moment(data.master?.reaception_at)
          .format('YYYY-MM-DD HH:mm')
        this.listSelectedLang = []

        const defaultData = {
          lang: LANGUAGE_CODES_FOR_DISEASE?.VI,
          patient_diagnostic:
            data.master?.treat_dept_main_name || data.medical_record_name || '',
          patient_diseases_current_cure: data.master?.pathological || '',
          treatment: data.master?.treatment_direction || ''
        }

        const newMultiLang = []
        const setForm = data => {
          _.forEach(data, value => {
            this.isViLangShowField = true
            this.form.patient_diagnostic.vi = value.patient_diagnostic || ''
            this.form.patient_diseases_current_cure.vi =
              value.patient_diseases_current_cure || ''
            this.form.treatment.vi = value.treatment || ''
            this.listSelectedLang.push(
              LANGUAGE_CODES_NUMBER_FOR_DISEASE[1].toLowerCase()
            )

            newMultiLang.push(defaultData)
          })
        }

        const defaultMultiLang = [defaultData]

        setForm(defaultMultiLang)

        this.multilang = newMultiLang
      } else {
        this.form.mr_id = null
        this.form.admission_date = ''
        this.form.date = appUtils.formatInputDate() || ''
        this.form.code = ''
        this.form.patient_diagnostic = {}
        this.form.patient_diseases_current_cure = {}
        this.form.treatment = {}

        this.aliasStatus = false
        this.alias_form.alias_id = null
        this.alias_form.alias_gender = 1
        this.alias_form.alias_name = ''
        this.alias_form.alias_age = ''
        this.alias_form.alias_address = ''
        this.alias_form.alias_pid = ''
        this.alias_form.alias_emr_id = ''

        this.showLang = LANGUAGE_CODES_NAME_FOR_DISEASE?.VI?.toLowerCase()
        this.isViLangShowField = true
        this.listSelectedLang = [this.showLang]
      }
    }
  }
}
</script>

<style  scoped>
.form-control fs-16 fw-500 txt-grey-900 {
  background: #ffffff;
  /* Neutral/300 */

  border: 1.5px solid #b4b4c4;
  border-radius: 10px;
  color: #616673;
}

label {
  margin-bottom: 10px;
}

.btn-save {
  height: 50px;
  width: 190px;
  border-radius: 8px;
  padding: 8px, 16px, 8px, 16px;
}

.upload-btn {
  border: 0.756458px dashed #20409b;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  flex: 1;
}

.upload-container {
  width: 50%;
  padding: 0.5%;
  margin-right: 16px;
}

.upload-btn:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.upload-input {
  width: 100%;
  outline: 0;
  border-width: 0 0 1px;
  border-color: #03014c;
  margin-top: 10px;
}

.region-disabled {
  opacity: 0.5;
  pointer-events: none !important;
}

.patient_name {
  text-transform: uppercase;
}
.patient_name::placeholder {
  text-transform: capitalize;
}
</style>
